module.exports = __webpack_public_path__ + "img/zoetrope3.c3be07d1.jpg";